import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-landeskennzeichen-list-view',
  imports: [],
  templateUrl: './landeskennzeichen.list-view.html',
  styleUrls: ['./landeskennzeichen.list-view.css'],
})
export class LandeskennzeichenListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
